/*************************************************
 *
 * English Strings Resource
 *
 *************************************************/
const English = {
  Buttons: {
    sign_in: 'Sign in',
    create_account: 'Create account',
    next: 'Next',
    cancel: 'Cancel',
    send: 'Send',
    scan_card: 'Scan card',
    ok: 'OK',
    add: 'Add',
    italy: 'Italy',
    usa: 'USA',
    uk: 'United Kingdom',
    canada: 'Canada',
    australia: 'Australia',
    switzerland: 'Switzerland',
    ireland: 'Ireland',
    netherlands: 'Netherlands',
    germany: 'Germany',
    spain: 'Spain',
    france: 'France',
    belgium: 'Belgium',
    sweden: 'Sweden',
    denmark: 'Denmark',
    norway: 'Norway',
    luxembourg: 'Luxembourg',
    austria: 'Austria',
    finland: 'Finland',
    save: 'Save',
    manual_card_entry: 'MANUAL CARD ENTRY',
    delete_card: 'Delete card',
    delete: 'Delete',
    edit: 'Edit',
    continue: 'Continue',
    one_time_purchase: 'One-time purchase',
    done: 'Done',
    checkout: 'Checkout',
    finish: 'FINISH',
    verify: 'VERIFY',
    start: 'START',
    stop: 'STOP',
    forgot_password: 'Forgot Password?',
    save_and_login: 'Save & Login',
    forgot_pin: 'Forgot pin?',
    receipt: 'Receipt',
    email_receipt: 'Email receipt',
    change_settings: 'Change settings',
    send_email: 'Send email',
    setup_auto_funding: 'Setup autofunding',
    try_again: 'Try again',
    add_card_and_checkout: 'Add credit/debit card & checkout',
    save_and_complete_purchase: 'Save & Complete Purchase',
    enroll: 'Enroll',
    got_it: 'Got it',
    add_card: 'Add card',
    confirm: 'Confirm',
    decline: 'Decline',
    request_refund: 'Request Refund',
    start_swiping: 'Start swiping!',
    im_done: "I'm done",
    signout: 'Sign out',
    setup_your_app: 'Setup your App!',
    go_to_payments: 'Go to payments',
    add_funds: 'Add funds',
    add_item: 'Add item',
    add_items: 'Add items',
    update_item: 'Update item',
    recent_orders: 'Recent Orders',
    special_instructions: 'Special Instructions',
    enter: 'Enter',
    clear: 'Clear',
    no_thanks: 'No Thanks',
    send_invite: 'Send Invite',
    lets_do_it: "Let's do it!",
    just_get_me_started: 'Just get me started',
    send_a_snack: 'Send a snack',
    view_more_gifts: 'View more gifts',
    unblock: 'Unblock',
    send_snack: 'Send Snack',
    fund_and_send_snack: 'Fund & Send Snack',
    accept_snack: 'Accept Snack',
    cancel_snack: 'Cancel Snack',
    block_user: 'Block user',
    operator: 'Operator',
    used_this_app: "I've used this app",
    never_used_this_app: "I've never used this app",
    start_a_quick_tour: 'Start a quick tour',
    skip: 'SKIP',
    lets_go: 'Let’s go!',
  },
  Labels: {
    add_funds: 'Add Funds',
    searching_machines: 'Searching for nearby markets and vending machines',
    bluetooth_classic: 'Bluetooth Classic',
    retry_connects: 'Retry Bluetooth Connections',
    email: 'Email',
    enter_email: 'Enter your email',
    password: 'Password',
    enter_password: 'Enter your password',
    enter_password_below: 'Enter your password below',
    enter_pin_to_continue: 'Enter your PIN to continue',
    pin: 'PIN',
    credit_card: 'Credit Card',
    enter_information: 'Enter your information below',
    create_account: 'Create Account',
    confirm_your_password: 'Confirm your password',
    confirm_password: 'Confirm Password',
    redirect_message: "Hang tight. We're getting you signed in.",
    skip: 'Skip',
    add_later: 'Add Later',
    account_balance: 'Account Balance',
    account_instructions:
      "To enable, either:\n1. Visit a kiosk and login to your account\n2. Get within range of your market's mobile solution\n3. Link to an order ahead location",
    browser_version_notice:
      'For the most seamless and supported user experience, please use an up to date version of Chrome.',
    name_text: 'Name',
    enter_your_pin: 'Enter your PIN',
    pin_required: 'PIN required on this device',
    accept_the: 'I accept the',
    verify_you_accept_required: 'Required: Verify that you accept the',
    terms: 'Terms and Conditions',
    user_agreement: 'User Agreement',
    confirm: 'Confirm',
    select: 'Select',
    add_amount: 'Add Amount',
    create_new_machine: 'Create New Machine',
    link_to_machine: 'Link to Existing Machine',
    unattached_machines: 'Unattached Machines',
    loading_machines: 'Loading Machines',
    back: 'Back',
    ok: 'OK',
    cash_bag: 'Cash Bag ID',
    change_pin: 'Change Pin',
    update_name: 'Update Name',
    change_password: 'Change Password',
    security: 'Security',
    current_password: 'Current Password',
    new_password: 'New Password',
    yes: 'Yes',
    no: 'No',
    comment: 'Comment',
    select_country: 'Select Your Country',
    select_machine: 'Select Your Machine',
    select_machine_model: 'Select Machine Model',
    create_machine: 'Create Machine',
    machine_model: 'Machine Model',
    machine_name: 'Machine Name',
    machine_identifier: 'Machine Identifier',
    add_credit_card: 'Add Credit Card',
    enter_credit_card_info: 'Enter your credit card information',
    card_number: 'Card Number',
    expiration: 'Expiration',
    expiration_month: 'Expiration Month',
    expiration_year: 'Expiration Year',
    cvc: 'CVC',
    cvv: 'CVV',
    zip_code: 'Zip Code',
    confirm_delete_card: 'Are you sure you want to delete this card?',
    confirm_set_as_default_card:
      'Are you sure you want to make this card as your default payment method?',
    confirm_delete_message: 'Are you sure you want to delete this message?',
    add_card: 'Add Card',
    add_new_payment: 'Add New Payment',
    confirm_unlink_device: 'Are you sure you want to Unlink this device?',
    confirm_reboot: 'Confirm Reboot?',
    device_settings: 'Device Settings',
    unlink_device: 'Unlink Device',
    vmc_diagnostics: 'VMC Diagnostics',
    reboot_device: 'Reboot Device',
    service_mode: 'Service Mode',
    service_completed: 'Service Completed',
    payment: 'Payment',
    add_credit_to_machine: 'Add credit to machine',
    user_info: 'User Info',
    address: 'Address',
    postal_code: 'Postal Code',
    city: 'City',
    province: 'Province',
    contact_us: 'Contact Technical Support',
    logout: 'Logout',
    sign_in: 'Sign In',
    tax_id: 'Tax ID',
    machine_rename_message:
      'Friendly name will be updated and AV Inside hardware will automatically reboot. Please wait 60 seconds and reconnect.',
    select_a_card:
      'Select the card to use and the amount to add (minimum of {0}) in order to make your desired purchase.',
    purchase_items_but_not_all:
      'You can purchase some items in the vending machine, but not all.',
    select_what_you_would_like_to_do:
      'Please select what you would like to do:',
    welcome_back: 'Welcome',
    welcome: 'Welcome!',
    pull_to_refresh: 'Pull to refresh to search for available machines.',
    enter_pin: 'Enter PIN',
    enter_valid_price: 'Please enter a valid price.',
    loading_planogram: 'Loading Planogram',
    price: 'Price',
    change_product: 'Change Product',
    select_product: 'Select Product',
    loading_products: 'Loading Products',
    nutrition_facts: 'Nutrition Facts',
    serving_size: 'Serving Size',
    amount_per_serving: 'Amount Per Serving',
    calories: 'Calories',
    calories_from_fat: 'Calories from Fat',
    daily_value: 'Daily Value',
    total_fat: 'Total Fat',
    saturated_fat: 'Saturated Fat',
    trans_fat: 'Trans Fat',
    cholesterol: 'Cholesterol',
    sodium: 'Sodium',
    total_carbohydrate: ' Total Carbohydrate',
    dietary_fiber: 'Dietary Fiber',
    sugars: 'Sugars',
    protein: 'Protein',
    search: 'Search',
    search_view: 'Search View',
    subtotal: 'Subtotal',
    tax: 'Tax',
    report_problem: 'Report a problem',
    reset_pin: 'Reset PIN',
    new_pin: 'New PIN',
    confirm_new_pin: 'Confirm New PIN',
    bottle_deposit: 'Deposit',
    machine_will_restart: 'The machine is going to restart.',
    select_product_on_the: 'Select Your Product on the',
    vending_machine: 'vending machine',
    vended: 'Vended',
    wifi_settings: 'WiFi Settings',
    wifi: 'WiFi',
    ssid_name: 'SSID/Name',
    requesting_dex_file: 'Requesting DEX File',
    actions: 'Actions',
    send_log: 'Send Log',
    reset: 'Reset',
    send_dex: 'Send Dex',
    send_credit: 'Send Credit',
    use_gma: 'Use GMA',
    demo_mode: 'Demo Mode',
    debug_messages: 'Debug Messages',
    language: 'Language',
    environment: 'Environment',
    loading: 'Loading',
    enter_id: 'Enter ID',
    card_type: 'Card Type',
    downloading_update: 'Downloading Update',
    required_update_avail_for_machine:
      'A required update is available for this machine. Would you like to install it?',
    newer_version_avail_for_machine:
      'A newer version is available for this machine. Would you like to install it?',
    sending_update: 'Sending Update',
    settings: 'Settings',
    last_updated: 'Last Updated',
    pull_dex_file: 'Pull DEX File',
    adjust_inventory: 'Adjust Inventory',
    test_vend: 'Test Vend',
    ip_address: 'IP Address',
    mac_address: 'MAC Address',
    app_version: 'App Version',
    os_version: 'OS Version',
    pic_version: 'PIC Version',
    device_id: 'Device ID',
    all: 'All',
    purchase: 'Purchase',
    funding: 'Funding',
    amount: 'Amount',
    balance: 'Balance',
    deposit: 'Deposit',
    new_balance: 'New Balance',
    rewards: 'Rewards',
    points: 'Points',
    connect: 'Connect',
    redeem_explanation: 'Redeem {0} points for {1} in account credit',
    redeem: 'Redeem',
    invite: 'Invite',
    invite_your_friends: 'Invite your friends, and get credit!',
    invite_friends_and_get: 'Invite your friends, and you both get',
    in_cash_to_spend_in_app: 'in cash to spend in-app!',
    invite_friends: 'Invite Friends',
    offer_expires_on:
      'Offer expires on {0} or once {1} participants have redeemed their reward',
    offer_expires_redeem:
      'Offer expires once {0} participants have redeemed their reward.',
    offer_expires_endDate: 'Offer expires on {0}',
    referrals_to_date: '{0} referrals to date',
    signups_achieved: '{0} signups achieved',
    account_already_setup_referral:
      'Sorry, that person already has an account. Please enter another lucky friend.',
    campaign_already_expired: 'Campaign already expired',
    reward_already_redeemed: 'Reward is already redeemed',
    unable_to_redeem: 'Unable to redeem the reward. Please try again later',
    error_sending_the_sms:
      'There was an error sending the SMS. Please try again later',
    error_sending_the_email:
      'There was an error sending the Email. Please try again later',
    scan_qr_canteen_connect: 'Scan Canteen QR Code to Connect',
    dismiss: 'Dismiss',
    configuring_wifi: 'Configuring WiFi',
    forgot_password: 'Forgot Password',
    enter_and_confirm_password: 'Enter and confirm your password',
    confirm_new_password: 'Confirm New Password',
    enter_your_info_to_continue: 'Enter your info below to continue',
    click_shop_to_scan:
      'We see you are near a market! Click Shop below to scan your first item',
    do_not_notify: 'Do not notify me again',
    change_email: 'Change Email',
    new_email: 'New Email',
    confirm_new_email: 'Confirm New Email',
    email_address: 'Email Address',
    text: 'Text',
    password_requirements: '8 or more characters',
    pin_requirements: '4 digits',
    first_name: 'First Name',
    last_name: 'Last Name',
    account: 'Account',
    adjustment: 'Adjustment',
    loyalty_credit: 'Loyalty Credit',
    scan_qr_code_from_kiosk: 'Scan QR code from Kiosk',
    market_card: 'Market Card',
    scan_market_card: 'Scan Market Card',
    enter_market_card: 'Enter Market Card',
    edit_market_card: 'Edit Market Card',
    add_market_card: 'Add Market Card',
    scan_connectandpay_card: 'Scan Connect & Pay® Card',
    scan_your_market_card: 'Scan your market card',
    scan_your_connectandpay_card: 'Scan your Connect & Pay® Card',
    manually_enter_email: 'Manually enter Email & PIN used on kiosk',
    manually_enter_email_only: 'Manually enter Email & PIN',
    create_password: 'Create Password',
    delete_account: 'Delete Account',
    voluntary_deletion_1:
      'Make sure the email address associated to your account is updated and accessible, as you will need that to retrieve any remaining funds. To update your email go to Settings > Personal Info, then return to the Account Deletion process.',
    voluntary_deletion_2:
      'If you continue, you will be consenting to deleting your account and will no longer be able to sign-in to your account from any device.\n\nAll personal information will be removed from the system.',
    open_your_account_kiosk_scan_QR_code_shown:
      'Open your account at the kiosk and scan the QR code shown.',
    enter_email_associated_with_this_account:
      "Enter the email you'd like associated with this account",
    camera_disabled:
      'Your privacy settings are preventing us from accessing your camera.',
    enter_email_for_confirmation:
      "Enter your email and we'll send you a link to confirm it!",
    when_funds_fall_below: 'When Funds Fall Below',
    auto_funding: 'Auto Funding',
    fund: 'Fund',
    turn_off_auto_funding: 'Are you sure you want to turn off Auto Funding?',
    setup_later: 'Setup Later',
    automatically_fund_your_account:
      'Automatically fund your account so you never run out of money! This will take effect immediately after setup.',
    you_must_be_within_range:
      'You must be within range of a market in order to create your account.',
    searching_for_market: 'Searching for Market...',
    ensure_you_are_close_to_market:
      'Ensure that you are within close proximity to a market and have Bluetooth enabled on your device.',
    unable_to_connect: 'Unable to connect',
    connected_to_market: 'Connected to market',
    remaining_credit: 'Remaining Credit',
    total_due: 'Total Due',
    insufficient_credit_remaining:
      'Insufficient Credit Remaining\nPlease add a credit/debit card to continue',
    cashless_device_settings: 'Cashless Device Settings',
    first_device: 'First Device',
    second_device: 'Second Device',
    account_already_has_password:
      'This account already has a password. Do you want to reset your password?',
    this_account_doesnt_have_password:
      "This account doesn't have a password yet",
    payroll_deduct: 'Payroll Deduct',
    payroll_deduct_id: 'Payroll Deduct ID',
    pending: 'Pending',
    pending_upper_case: 'PENDING',
    enroll: 'Enroll',
    delete_payroll_deduct: 'Are you sure you want to delete Payroll Deduct?',
    verify_country_location: 'Verify that {0} is your current location.',
    is_this_correct: 'Is this correct?',
    authorizing: 'Authorizing...',
    discount_message: 'Save {0} when paying by {1}',
    you_saved_paying: 'You saved {0}!',
    you_received_rewards: 'You have received {0} reward points!',
    payroll_deduct_enroll_message:
      'Enter the Payroll ID provided by your Office Administrator. Once verified, you will recieve a notification and be able to select Payroll Deduct to fund your account.',
    payroll_deduct_enrollment: 'Payroll Deduct',
    before_you_begin: 'Before you begin...',
    if_youre_not_sure: "If you're not sure",
    click_here: 'click here',
    to_ask_us: 'to ask us!',
    make_sure_location_supports:
      'Make sure your location supports the {0} app. Check with your office administrator to find out.',
    not_enrolled: 'Not enrolled',
    enroll_now: 'Enroll now',
    no_cards_available: 'No Credit Cards Available',
    add_card_to_fund_account: 'Add a card to easily fund your account.',
    funding_summary: 'Funding Summary',
    account_funding: 'Account Funding',
    total: 'Total',
    discounts: 'Discounts',
    privacy_policy: 'Privacy Policy',
    updated_privacy_policy: 'Updated Privacy Policy',
    agree_to_privacy_policy: 'I agree to the above Privacy Policy',
    view_privacy_policy: 'View Privacy Policy',
    view_terms_and_conditions: 'View Terms & Conditions',
    declining_privacy_policy:
      'By declining the Privacy Policy, you are choosing to close your account.\nAre you sure you want to close your account?',
    all_products: 'All Products',
    filter_by_name: 'Filter by Name',
    funding_total: 'FUNDING TOTAL',
    incompatible_currency: 'Incompatible Currency',
    no_processor: "Doesn't Accept Credit Cards",
    discount: 'Discount',
    confirm_refund: 'Confirm Refund',
    refund_confirmation_message:
      'Refunding this transaction will refund back to the original card used to fund and the money will be removed from your account balance.',
    funding_refund_request: 'Funding Refund Request',
    balance_available: 'Balance Available',
    total_refunded: 'Total Refunded',
    summary: 'Summary',
    refund: 'Refund',
    account_funding_refund: 'Account Funding Refund',
    eat_it_or_delete_it: 'Eat It or Delete It',
    welcome_to_eat_it_or_delete_it: 'Welcome to Eat It or Delete It',
    eat_it_or_delete_it_instruction:
      'Use this feature to share your opinions about the product offering in your Avenue C and help us improve the selection.',
    eat_it_or_delete_it_scan_instruction:
      'To get started, locate and scan the Eat It or Delete It QR code by the kiosk in your Avenue C.',
    swipe_left_to_dislike: 'Swipe left to Dislike',
    swipe_up_to_skip: 'Swipe up to Skip',
    swipe_right_to_like: 'Swipe right to Like',
    scan_qr_to_go_to_eat_it_or_delete_it: 'Scan your Market QR Code to begin',
    your_funding: 'Your Funding',
    no_image_available: 'NO IMAGE AVAILABLE',
    congratulations: 'Congratulations!',
    eat_it_or_delete_it_completed:
      "You've reviewed every item. Thank you for helping improve the product selection in your Avenue C.",
    keep_going: 'Keep Going?',
    swipe_on_or_take_a_break:
      'Swipe on or take a break and come back later to review more products - your choice.',
    promotion_description_minimum: 'if you spend at least {0}',
    promotion_description_savings: 'to save {0}',
    or: 'or',
    add_a: 'Add a',
    promotion_description_limit: '*Limit {0} per transaction',
    scan_this_at_checkout: 'Scan this at checkout',
    gender: 'Gender',
    birth_month: 'Birth Month',
    birth_year: 'Birth Year',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    support_id: 'Support ID: {0}',
    gst: 'GST',
    pst: 'PST',
    offline_message:
      'You are offline. Please check your internet connection and try again.',
    your_balance: 'Your Balance',
    home: 'Home',
    shop: 'Shop',
    inbox: 'Inbox',
    add_to_apple_wallet: 'Add to Apple Wallet',
    help_and_other: 'Help and Other',
    history: 'History',
    personal_info: 'Personal Info',
    already_have_account: 'Already have a kiosk account?',
    if_you_already_created_an_account:
      "If you've already created an account at a kiosk or online, you can setup your app here!",
    continue_to_create_account: 'If not, continue to create a new account',
    setup_app: 'Setup App',
    select_link_account_method:
      "Select the method with which you'd like to link your account",
    optional: 'Optional',
    job_title: 'Job Title',
    demographics: 'Demographics',
    no_messages: 'No messages',
    markets: 'Markets',
    as_of: 'as of',
    add_money_to_your_account: 'Add money to your account',
    auto_reload: 'Auto reload',
    when_balance_is_below: '{0} when balance is below {1}',
    click_edit_to_turn_on: 'Click Edit to turn on',
    edit_auto_reload: 'Edit Auto reload',
    in_order_to_reload_your_account:
      'In order to reload your account, please go to payments and add a payment method.',
    no_payment_method: 'No Payment Method',
    insufficient_balance: 'Insufficient Balance',
    add_funds_to_complete_transaction:
      'Please add funds to complete the transaction.',
    open_scanner: 'Open Scanner',
    due_amount: 'due amount',
    which_location_are_you_inquiring_about:
      'Which location are you inquiring about?',
    location_details_prompt:
      'Please include details of the location you are at such as Name, Address, Building, Company, etc. and we will get back to you and let you know if your app is accepted at this location.',
    help_details_prompt:
      'Please include details of your questions or issues you may have and we will get back to you.',
    position_card_in_frame: 'Position your card in the frame.',
    redesign_subject: 'Welcome to the NEW {0}!',
    redesign_content:
      'Welcome to the NEW {0} mobile app. As you can tell we have created a new and improved version of {0} to help you, as the user, earn more and learn more! With our new home tab, getting to the things you need has never been easier. With funding, balance, promotions and more all at your fingertips!',
    yesterday: 'Yesterday',
    today: 'Today',
    faq: 'Popular Questions',
    help: 'Help',
    how_request_refund: 'How do I request a refund?',
    how_request_refund_answer:
      'Great news! If you funded your account using the app or MyMarketAccount.net, and that funding occurred within the last 90 days, you can request a refund right from the app! First, ensure Auto Reload has been turned off. Then click on the ‘Settings’ tab and then on ‘History’, from here choose the funding event you would like refunded, click ‘Request Refund’ and follow the on-screen prompts.\n\nIf you need a refund for a purchase or a funding event that occurred at a kiosk or more than 90 days ago please contact your Market Provider. If you are unsure how, contact your Human Resources or Facilities department for more information.',
    faq_market_compatible: 'Is my market location compatible with the {0} app?',
    faq_market_compatible_answer:
      'Contact your Market Provider to find out if your device is compatible with the {0} app and Global Market Account enabled!',
    faq_diff_balance: 'Why is my balance different on the app than the device?',
    faq_diff_balance_answer:
      'The most likely reason for your balance appearing to be different on the app than it is on the device is that the device in the market is offline. When the device is offline, it’s not syncing and thus not updating account balances. Please wait until the device has regained connection and the balance will update.',
    faq_fingerprints: 'How do I add a Fingerprint or ScanID to my account?',
    faq_fingerprints_answer:
      'This must be done at the kiosk/tablet itself. Visit your market, login to your account on the kiosk using your in app QR code. From here you will be taken to the Manage Account screen, where you can then add a ScanID (Market Card) or a Fingerprint.',
    faq_auto_reload: 'How do I turn off Auto Reload?',
    faq_auto_reload_answer:
      'Navigate to the Home screen and press the center button with the $ on it. Click ‘Edit’ next to the Auto reload section. Toggle the switch off and click save, confirm. You are good to go!',
    faq_auto_reload_answer_web:
      'In the top right click ‘Your Balance’ or ‘Add Funds’. Click ‘Edit’ next to the Auto reload section. Toggle the switch off and click save, confirm. You are good to go!',
    contact_us_answer:
      'Having technical issues and couldn’t find the answer above? Please contact us today by sending an email to {0}.',
    latest_transactions: 'Latest Transactions',
    view_more_transactions: 'View more transactions',
    refund_past_90_days:
      'Refunds are not available because this funding event occurred more than 90 days ago. Please contact support with further questions.',
    faq_bad_scan: 'Why can’t I scan an item?',
    faq_bad_scan_answer:
      'If you are not seeing the camera view in order to purchase items using the Scan and Pay feature. You must navigate to your mobile device settings and Allow Camera Access in the {0} app.\n\nOnce this has been done, launch the app and you will then be prompted with the camera view.  \n\nIf you simply are not able to scan an item due to a difficult barcode, damaged UPC or other reasons, use the Search function to enter the item’s name and add to your cart.',
    faq_no_notifications: "Why don't I get notifications?",
    faq_no_notifications_answer:
      'You must navigate in your phones settings and enable push notifications for the {0} app. Once you enabled, launch the app and moving forward you should receive push notifications.',
    faq_no_notifications_answer_web:
      'You must navigate in your browsers settings and enable push notifications for this website. Once you enabled, refresh the web page and moving forward you should receive push notifications.',
    faq_no_locations: "Why don't I see the shop locations?",
    faq_no_locations_answer:
      'Turn on Bluetooth in the settings on your mobile device. Once Bluetooth is on, launch the app and your nearby Scan and Pay enabled locations should appear in the Shop tab.',
    faq_link_market_card: 'How do I link a Market Card to my account?',
    faq_link_market_card_answer:
      'Go to the kiosk and scan your {0} QR code to access your account. Select "Setup Scan ID", scan your new market card, and save your account!',
    faq_product_issue: 'I have a Product Issue or Request, who do I contact?',
    faq_product_issue_answer:
      'If you have an issue with any product purchased in your market, as well as any product requests please reach out to your Market Provider. Ask your HR/Office Manager to acquire their contact info.',
    faq_reward_points: 'What happened to my Rewards Points?',
    faq_reward_points_answer:
      'If you have accrued enough Rewards Points to reach a redeemable threshold at the beginning of each quarter (January, April, July and October), your Rewards Points will be automatically redeemed. The remainder of your points will roll over to the next period and will not expire.',
    faq_add_order_ahead_location:
      'How do I add a location to order food using Order Ahead?',
    faq_add_order_ahead_location_answer:
      'The cafe manager will provide you a six digit alphanumeric code to enter. Select ‘Shop’ button and Link Location. Enter the code and hit Save.',
    faq_order_ahead_checkout:
      'How do I checkout with Order Ahead once I am finished adding items to my cart?',
    faq_order_ahead_checkout_answer:
      'Once you’ve added items to your cart in the Shop tab under your Order Ahead location. Select the blue shopping bag icon just above the Settings button to navigate to your cart. Review your order and select Checkout when ready.',
    faq_remove_items: 'How do I remove items from my cart?',
    faq_remove_items_answer:
      'From your shopping cart, swipe to the left on the item you wish to remove. Then select the remove button when it appears.',
    faq_payment: 'How can I pay for Order Ahead orders?',
    faq_payment_answer:
      'When you checkout, your order will select your Market Connect account as it’s payment method. If you have any balance in your account those funds will be used. If you don’t, you’ll be presented with either your saved credit card or Apple Pay to pay for the items.',
    until_disconnect: 'Until Disconnect',
    vat: 'VAT',
    mobile_locations: 'Mobile Locations',
    locations: 'Locations',
    notifications: 'Notifications',
    points_earned: 'points earned',
    expires: 'Expires',
    claim: 'Claim',
    ends: 'Ends',
    bought_x_of_y: 'Bought {0} of {1}',
    x_down_y_to_go: '{0} down, {1} to go',
    messages: 'Messages',
    active_offers: 'Active Offers',
    past_offers: 'Past Offers',
    account_not_available: 'Account Not Available Here',
    expired: 'Expired',
    claim_deal_title: 'You have now activated this offer.',
    claim_deal_message:
      'To redeem, ensure all offer criteria are met and simply checkout using your account.',
    goal_achieved: 'Goal Achieved!',
    redeemed_x_times: 'Redeemed {0} Times!',
    redeemed_1_time: 'Redeemed 1 Time!',
    promotion: 'Promotion',
    link_new_location: 'Link New Location',
    link_location: 'Link Location',
    location_code: 'Location Code',
    please_enter_location_code: 'Please enter your provided alphanumeric code',
    enter_your_location_code: 'Enter your location code',
    scan_and_pay: 'Scan & Pay',
    order_ahead: 'Order Ahead',
    pickup_today: 'Pickup today at {0}',
    pickup_tomorrow: 'Pickup tomorrow at {0}',
    pickup_date: 'Pickup Date',
    pickup_time: 'Pickup Time',
    pickup_location: 'Pickup Location',
    menu: 'Menu',
    pickup_at: 'Pickup at',
    required: 'Required',
    remove: 'Remove',
    remove_location: 'Remove Location',
    are_you_sure_remove_location:
      'Are you sure you would like to remove this location from your saved list?',
    complete_checkout: 'Complete Checkout',
    processing_sale: 'Processing Sale',
    adding_funds: 'Adding Funds',
    preparation_method: 'Preparation Method',
    to_go: 'To go',
    dine_in: 'Dine in',
    to_go_only: 'To-Go Only',
    dine_in_only: 'Dine-In Only',
    locker_only: 'Locker Only',
    change: 'Change',
    your_order_is_empty: 'Your order is empty',
    your_order_sent: 'Your order is sent',
    your_order_preparing: 'Your order is being prepared',
    your_order_ready: 'Your order is ready!',
    your_order_expired: 'Your order has expired.',
    your_order_received: 'Your order has been received.',
    your_order_retrieved: 'Your order has been retrieved.',
    item_info: 'Item Info',
    quantity: 'Quantity',
    cancel_order_confirm: 'Are you sure you would like to cancel your order?',
    cancel_order: 'Cancel Order',
    system_language: 'System Language',
    system_language_explanation:
      'Language setting used by {0} Services such as Email communications',
    out_of_service: 'Out of Service',
    start_now: 'Start Now',
    coffee_machine: 'Coffee Machine',
    start_brewing: 'Start Brewing',
    dispensed: 'is being dispensed',
    please_place_cup_and_enter_code: 'Please place your cup and enter code',
    scan_qr_code_from_coffee_machine:
      'Scan the QR code found on your Coffee Machine',
    order_status: 'Order Status',
    preparing_order: 'Preparing Order',
    order_ready: 'Order Ready',
    order_received: 'Order Received',
    order_sent: 'Order Sent',
    order_expired: 'Order Expired',
    order_retrieved: 'Order Retrieved',
    select_your_beverage: 'Select Your Beverage',
    re_enter_password: 'Re-Enter Password',
    re_enter_pin: 'Re-Enter PIN',
    dispense: 'Dispense',
    please_note: 'Please Note',
    add_all: 'Add all',
    no_recent_orders: 'No recent orders',
    unavailable: 'Unavailable',
    modifiers_changed: 'Options Changed',
    modifiers_changed_prompt:
      'Options have changed. Would you still like to add order to the cart?',
    items_added: '{0} items added',
    item_added: '{0} added',
    feedback: 'Feedback',
    have_feedback: 'Have feedback?',
    feedback_info:
      'Please contact Anthony Miroddi at Anthony.Miroddi@foodworks.org. Please reference the day/time of your visit.',
    faqs_and_tech_support: 'FAQs & Tech Support',
    size: 'Size',
    bold: 'Bold',
    leave_room: 'Leave room',
    leave_room_in_coffee: 'Leave room in coffee',
    preparing_your_drink: 'Preparing your drink',
    enrollment_pending: 'Enrollment Pending',
    notify_your_office_admin:
      'Notify your office admin to speed up the process.',
    payroll_deduct_authorization_agreement:
      'Payroll Deduct Authorization Agreement',
    payroll_deduct_agreement: 'Payroll Deduct Agreement',
    payroll_deduct_agreement_text:
      'Through the use of Payroll Deduct you are authorizing your employer to withhold funds from your payroll to fund or pay for purchases. It is the responsibility of you as the consumer to understand all associated actions. Please contact your employer for additional questions you may have regarding using payroll deduct.',
    remaining: 'Remaining',
    x_of_y: '{0} of {1}',
    pay_cycle: 'Pay Cycle',
    resets_on: 'Resets on {0}',
    spend_limit: 'Spend Limit',
    opt_in: 'Opt-in',
    opting_out_of_payroll_deduct:
      'Opting out of payroll deduct will remove the ability to fund with payroll deduct. You can always opt-in at a later date, if you change your mind.',
    would_you_like_to_manage_payroll_deduct:
      'Would you like to manage your payroll deduct now?',
    payroll_deduct_now_available: 'Payroll Deduct Now Available',
    sold_out: 'Sold Out',
    characters_left: 'characters left',
    enter_special_instructions: 'Enter your instructions here...',
    order_note: 'Order Note',
    make_your_selection: 'Make your selection using the keys below',
    selection: 'Selection',
    required_keypad_not_recognized: 'The requested keypad was not recognized',
    barcode_refocus_and_find_non_barcoded_items:
      'To re-focus on your barcode, tap the viewfinder window. Click the magnifying glass above to search items by text.',
    instant_discounts: 'Instant Discounts',
    current_offers: 'Current Offers',
    pickup_time_selected_serving_different_menu:
      'The pickup time selected is serving a different menu. Your cart will be emptied if you continue.',
    menu_change: 'Menu Change',
    vended_item: 'Vended Item',
    item_vended: 'Item Vended',
    vending: 'Vending',
    ready: 'Ready',
    great_deals_your_free: 'Great deals and your free',
    is_just_few_steps_away: 'is just a few steps away!',
    unfortunately_your_reward_has_expired:
      'Unfortunately, your reward has expired.',
    but_savings_and_convenience:
      'But savings and convenience is just a few steps away by completing your registration!',
    sign_up: 'Sign up',
    sign_up_reward: 'Sign-Up Reward',
    referral: 'Referral',
    referral_reward: 'Referral Reward',
    new_sign_up: 'New Sign-Up: {0}',
    referrer_name: 'Referrer: {0}',
    your_friend_joined: 'Your friend {0} that you invited has joined!',
    thanks_for_joining: 'Thanks for joining {0}!',
    reward_expired: 'Unfortunately, your reward has expired.',
    successfully_claimed_reward: "You've successfully claimed your reward.",
    here_is_your_referral_amount: 'Here is your {0} reward!',
    claimed: 'Claimed',
    your_account_is_ready: 'Your account is ready!',
    dont_forget_to_check_inbox: "Don't forget to check your inbox to redeem ",
    have_fun_shopping: 'and have fun shopping!',
    claimed_successfully: 'Claimed Successfully',
    enter_colon_code: 'Enter: {0}',
    ready_to_pick_up: 'Ready to pick up!',
    pickup_options: 'Pickup options',
    view_order: 'View order',
    scan_this_qr_code: 'Scan this QR Code',
    enter_code: 'Enter {0}',
    receipt: 'Receipt',
    email_receipt_to: 'Email Receipt To',
    text_receipt_to: 'Text Receipt To',
    print_receipt: 'Print Receipt',
    text_receipt: 'Text Receipt',
    email_receipt: 'Email Receipt',
    share: 'Share',
    receipt_share_text:
      "Your pickup options for your order placed at {0} locker '{1}' can be retrieved here >>> {2} or use {3} as pickup code.",
    locker_pickup_instruction:
      'Orders will be discarded {0} minutes after selected pickup time.',
    gift_feed: 'Gift feed',
    gift_feed_title: 'Gift Feed',
    no_gift_to_display: 'No Gifts to Display',
    gift_feed_snack_message: '{0} sent {1} a snack.',
    sent_you_snack: '{0} sent you a snack!',
    your_snack_sent: 'Your snack has been sent!',
    we_have_sent_your_snack: 'We’ve sent your {0} snack to {1}.',
    send_a_snack_title: 'Send a Snack',
    blocked_users: 'Blocked Users',
    no_users_blocked_snack_msg:
      'Looks like you have a lot of friends. No users blocked here.',
    choose_a_sticker: 'Choose a Sticker',
    gift_amount: 'Gift Amount ($1.00 minimum)',
    your_message: 'Your Message',
    to: 'To:',
    choose_from_contacts: 'Choose from contacts',
    private: 'Private',
    choose_contact: 'Choose Contact',
    we_have_sent_your_snack_details: 'We’ve sent your snack to {0}.',
    cancel_snack_button_description_message:
      'If you would like to cancel this please press the button below.',
    snack_has_been_accepted: 'Snack has been accepted.',
    snack_has_been_cancelled: 'Snack has been cancelled.',
    snack_has_expired: 'Snack has expired.',
    accept_snack_to_add_to_your_account:
      "'Accept Snack' to add to your account.",
    has_been_added_to_your_account: 'has been added to your account',
    gift_has_been_cancelled: 'gift has been cancelled.',
    gift_has_expired: 'gift has expired.',
    blocking_user_will_prevent_from_accept_snack:
      'Blocking a user will prevent you from being able to accept gifts from them.',
    are_you_sure_to_block_user: 'Are You Sure You Want to Block User?',
    user_can_be_unblocked_from_settings:
      'Users can be unblocked from settings.',
    yes_block: 'Yes, Block',
    blocked: 'Blocked',
    snack_credit: 'Snack Credit',
    balances: 'Balances',
    my_account: 'My Account',
    subsidy: 'Subsidy',
    tomorrow: 'Tomorrow',
    balance_transfer: 'Balance Transfer',
    manual_entry: 'Manual Entry',
    add_payment_card: 'Add Payment Card',
    add_egift_card: 'Add eGift Card',
    enter_egift_card_number: 'Enter eGift Card Number',
    all_new_to_me: 'This is all new to me!',
    dont_have_existing_account: "Don't have an\nexisting\naccount?",
    account_on_kiosk_or_received_login:
      'Have you\ncreated an\naccount on a\nkiosk or\nreceived login\ncredentials/\nscan card?',
    link_existing_account: 'Link Existing Account',
    get_you_going: "Let's get you going",
    enter_email_and_send_link:
      "Enter your email and we'll send you a link to confirm it!",
    send_link_to_email: 'Send the link\nto your email',
    click_here_to_continue: 'Click here to\ncontinue',
    select_method_to_link_account:
      "Select the method with which you'd like to link your account",
    set_as_default: 'Set as Default',
    this_card_is_set_as_your_default:
      'This card is set as your default. To change, add and select another payment method.',
    charity_round_up: 'Charity Round Up',
    swipe_to_continue: 'SWIPE TO CONTINUE',
    welcome_tour_title: 'Welcome to {0}!',
    welcome_tour_description: 'Take a quick tour so we can show you around',
    fund_tour_title: 'Fund',
    fund_tour_description:
      'Check your balances, add a credit card or fund your account',
    shop_tour_title: 'Shop',
    shop_tour_description:
      'Shop tells you when you are near a market and allows you to quickly scan and pay for products as well as order ahead (where available)',
    scan_tour_title: 'Scan',
    scan_tour_description:
      'Scan your personal QR code. Scan it at the kiosk after scanning products for a quick and easy checkout or scan it first to manage your account.',
    deals_tour_title: 'Deals',
    deals_tour_description: 'Check your Inbox for promotions and offers.',
    manage_tour_title: 'Manage',
    manage_tour_description:
      'Settings is where you will manage your account, view your history, see your security settings, get help and more.',
    done_tour_title: 'That’s it!',
    done_tour_description: 'You’re ready to get started',
  },
  Errors: {
    failed: 'Failed',
    enter_username_password: 'Please enter a username and password',
    enter_email: 'Please enter your email',
    login_failure:
      'Invalid email or password. Also be sure your email is verified before attempting to login.',
    all_fields_required: 'All fields are required.',
    all_fields_except_address_2_required:
      'All fields except Address 2 are required.',
    pin_has_to_be_four_digits: 'The pin has to be four digits.',
    password_has_to_be_eight_characters:
      'The password has to be at least eight characters.',
    passwords_must_match: 'Passwords must match.',
    passwords_do_not_match: "Passwords don't match.",
    must_accept_user_agreement: 'You must accept the User Agreement.',
    emails_do_not_match: "Emails don't match.",
    invalid_email: 'Email is invalid.',
    pins_do_not_match: "Pins don't match.",
    must_accept_terms: 'You must accept the Terms and Conditions',
    must_accept_privacy_policy_toggle: 'You must accept the Privacy Policy.',
    must_accept_privacy_policy: 'Must scroll to the bottom and accept policy.',
    problem_creating_account: 'There was a problem creating the account.',
    check_internet_connection:
      'Make sure you are connected to the internet and try again.',
    uh_oh: 'Uh-Oh!',
    error: 'There was an error',
    select_account_and_amount: 'Please select an account and an amount.',
    minimum_amount_is: 'The minimum amount you can add is',
    invalid_amount: 'Please enter a valid amount.',
    failed_to_add_funds: 'Failed to add funds.',
    error_finalizing_order:
      'There was an error finalizing your order. Please check your internet connection and try again.',
    qr_code_not_recognized: 'The QR Code was not recognized.',
    code_not_recognized:
      'We’re having trouble reading your Market Card. Please go back to the kiosk and enter your email on your account to continue.',
    connectandpay_not_recognized:
      "We're having trouble reading your Connect & Pay® Card. Please go back to the kiosk and enter your email on your account to continue.",
    error_loading_machines: 'There was an error loading the machines.',
    error_loading_cards: 'There was an error loading your cards.',
    error_loading_transaction:
      'There was an error loading the transaction detail.',
    email_required: 'An email is required!',
    error_creating_machine: 'There was an error creating a machine',
    select_model_and_machine: 'Please select a model and enter a machine name.',
    error_adding_credit_card:
      'There was an error adding the credit card to your account.',
    error_updating_credit_card:
      'There was an error editing or deleting the credit card on your account.',
    error_setting_default_credit_card:
      'There was an error setting default credit card.',
    error_unlinking_device:
      'Unable to un-link the device at this time, please try again',
    problem_processing_image:
      'There was a problem processing the image. Please try again.',
    nutrition_info_not_available:
      'Nutrition information is not available for this machine.',
    could_not_send_email: 'Could not send email. Please send an email to',
    unable_to_connect_with_vending_machine:
      'Unable to connect with Vending Machine.',
    notification_sent_to_operator:
      'A notification has been sent to the Vending Machine Operator',
    invalid_key: 'The key is invalid',
    unable_to_vend:
      'Unable to vend. Make sure you are connected to the internet.',
    cannot_make_purchase:
      'You do not have sufficient funds to make a purchase.',
    no_machines_found:
      'Pull down to search for nearby markets and vending machines',
    device_has_reset:
      'Device has been reset, please select serial # of device to configure.',
    no_communication_to_vending_machine:
      'No communication to Vending Machine, certain functionality will be unavailable.',
    unable_to_connect_to_vending_machine:
      'Unable to connect to the vending machine. Please try again later.',
    unable_to_connect_to_machine: 'Unable to connect to machine.',
    must_have_internet_to_confirm_pin:
      'You must have internet connection to confirm pin. Please check your connection and try again.',
    chances_left_to_enter_pin:
      'chance(s) left to enter correct PIN, or you will be signed out.',
    invalid_price: 'Invalid price!',
    product_list_not_available:
      'The product list is not available at this time.',
    enter_new_pin: 'Please enter a new pin',
    problem_changing_pin: 'There was a problem changing your pin.',
    barcode_not_recognized: 'Barcode not recognized, please rescan item.',
    item_failed_to_vend: 'Item failed to vend. Please try again later.',
    wifi_settings_cannot_be_empty: "WiFi Settings can't be empty",
    failed_to_upload: 'Failed to upload. Please try again later.',
    log_failed_to_send: 'Log failed to send',
    mdb_not_available: 'MDB is not available to send credit',
    dex_not_active_or_mdb_not_available:
      'Dex is not active on this machine or MDB is not available',
    must_enter_matching_password:
      'You must enter a password and they must match',
    error_sending_update:
      'An error occurred sending the update to the machine. Would you like to try again?',
    error_downloading_update:
      'An error occurred downloading the update. Please try again later. Error code: {0}',
    unable_to_read_code_please_try_again:
      'Unable to read code. Please try again.',
    unable_to_establish_connection: 'Unable to establish a connection.',
    unable_to_set_password:
      'Unable to set password. Make sure your password is at least 8 characters.',
    invalid_email_or_pin: 'Invalid email or pin.',
    invalid_pin: 'Invalid pin',
    error_emailing_receipt: 'There was an error emailing your receipt.',
    unable_to_change_email:
      'An error occurred changing your email address. Please try again later.',
    current_password_is_not_correct:
      'The current password is not correct, please enter a valid password.',
    email_already_exists:
      'The email address specified already exists on another account.',
    bluetooth_off:
      'Bluetooth is turned off. Turn Bluetooth ON to find nearby market/vending machines.',
    error_verifying_account:
      'Unable to verify your account. Please check your internet connection and try again.',
    error_setting_auto_funding:
      'There was an error setting up Auto Funding. Please try again later.',
    password_not_long_enough:
      'Minimum Password length required is 8 characters.',
    problem_setting_device:
      'There was a problem setting the device. Please try again.',
    account_already_setup:
      'This account has already been set up. Please login.',
    error_enrolling_payroll_deduct:
      'There was a problem enrolling in Payroll Deduct',
    payroll_deduct_id_exists:
      'Payroll Deduct ID already exists. Please choose a unique ID.',
    error_deleting_payroll: 'There was a problem removing Payroll Deduct',
    please_enter_valid_email:
      'The email is invalid, please enter a valid email.',
    error_issuing_refund: 'There was an error issuing the refund.',
    failed_to_add_pass: 'Failed to add to Apple Wallet',
    please_try_again: 'Please Try Again',
    error_scanning_qr_code: 'Error Scanning QR Code',
    this_feature_is_not_available_for_this_location:
      'This feature is not available for this location.',
    eat_it_or_delete_it_not_available: 'Eat It or Delete It Not Available',
    network_unavailable: 'Network Unavailable',
    network_not_available:
      'The network is not available.  Please check your network configuration in the Settings app.',
    funding_unavailable: 'Funding Unavailable',
    eGift_card_already_used: 'eGift card already used',
    eGift_card_expired: 'e-Giftcard is expired',
    already_linked_to_home_location:
      'It looks like you are already linked to a home location.',
    oops: 'Oops!',
    dont_know_location_code:
      "Contact your office administrator if you don't know your location code.",
    invalid_location_code: 'Invalid Location Code',
    order_ahead_unavailable:
      'Order ahead is currently unavailable at this time.',
    required_modifier: 'Please select required options.',
    cart_expired: 'Cart Expired',
    cart_expired_message:
      'It is past your pickup time, therefore your cart has been reset.',
    reached_payroll_deduct_limit:
      "You've reached your payroll deduct spend limit. Please use a different method to fund account.",
    pickup_time_not_available:
      'The pickup time is no longer available. Please select another pickup time.',
    coffee_machine_unavailable:
      'Coffee Machine unavailable currently. Please try again later.',
    invalid_code_entered: 'Invalid Code entered',
    your_item_could_not_dispense:
      'Your item could not dispense, please try again.',
    were_sorry: "We're Sorry",
    please_try_again_shortly: 'Please try again shortly.',
    no_size_options_available: 'No size options are available.',
    unable_to_retrieve_menu: 'Sorry! Unable to retrieve the menu. Try again.',
    sorry: 'Sorry!',
    promotion_only_available_market:
      'This promotion is only available in your local market. Visit your market to receive your discount!',
    invalid_market_card: 'Invalid Market Card',
    please_scan_valid_market_card: 'Please scan a valid Market Card',
    error_fetching_payroll:
      'There was an error fetching your payroll information.',
    error_saving_your_selection: 'There was an error saving your selection.',
    invalid_import_id: 'Link is invalid',
    scan_code_exists_error:
      'Scancode is already associated to another account.',
    payroll_link_location_error:
      'Error linking account, your home location is not valid.',
    payroll_id_exists_error:
      'Payroll ID is already associated to another account.',
    sold_out_remove_item:
      'One or more of your cart items are sold out.  Please remove them to checkout.',
    discount_available_at_kiosk:
      'Please visit your market to redeem this offer.',
    you_must_be_within_range_to_redeem_discount:
      'This offer features an instant discount that will be automatically applied when you purchase this qualifying product in your market.',
    invalid_selection: 'Invalid Selection',
    deal_already_claimed: 'This deal has already been claimed.',
    internet_issue: 'Please check your internet connection and try again.',
    unable_to_save_changes: 'Unable to save changes',
    error_sharing_receipt:
      'There was an error sharing the receipt. Please try again later',
    please_enter_the_valid_email: 'Please enter valid email',
    please_enter_valid_phone_number: 'Please enter valid phone number',
    minimum_snack_gift_amount: 'Minimum amount is $1.00.',
    unable_to_send: 'Unable to Send',
    person_cannot_receive_snack_error:
      'We’re sorry, but this person cannot receive snacks.',
    error_saving_user_send_snack_status:
      'There was an error updating your send a snack status. Try again.',
    error_fetching_blocked_users: 'There was an error fetching blocked users.',
    you_cannot_snack_to_yourself: 'You cannot send a snack to yourself!',
    snack_already_accepted: 'Snack already accepted.',
    snack_user_already_blocked: 'User already blocked.',
    snack_already_cancelled: 'Snack already cancelled.',
    error_loading_transaction_after_checkout:
      "Your order has been recorded, but we're unable to retrieve the receipt details at this time, please check back later in the history screen.",
    no_pickup_times_available: 'No Pickup Times Available',
    please_add_phone_number: 'Please add phone number',
    there_was_problem_linking_your_device:
      'There was a problem linking your device.',
    user_login_credentials_is_not_valid:
      "Your credentials may only work on either Connect & Pay or Canteen Pantry. If the current app isn't working, please download the other and attempt to login again.",
    location_service_off:
      'Enable Location Services for the 365Pay app to see nearby locations.',
  },
  Success: {
    success: 'Success!',
    password_changed: 'Password successfully changed!',
    credit_card_added: 'Credit card added successfully!',
    gift_card_added: 'eGift card added successfully!',
    device_unlinked: 'Device has successfully been un-linked',
    pin_no_longer_required: 'Pin no longer required',
    pin_changed: 'Pin successfully changed!',
    dex_retrieved: 'Dex successfully retrieved!',
    dex_uploaded: 'Dex successfully uploaded!',
    log_sent: 'Log sent successfully',
    update_transfer_success: 'Update transfer success.',
    update_restart: 'The machine will now update and restart.',
    connection_successful: 'Connection successful',
    email_has_been_sent:
      'If you entered a valid email address, you will receive an email with instructions to reset your password.',
    hasBeenAddedToYourAccount: '{0} has been added to your account!',
    update: 'Update',
    email_updated: 'Your email has been updated!',
    auto_funding_successfully_set: 'Auto Funding has been successfully set!',
    auto_funding_successfully_set_login:
      'Account has been created with\nauto funding enabled!\nLogin to use your account.',
    an_email_has_been_sent:
      'An email has been sent. Click on the link in the email to finish creating your account.',
    verify_email_has_been_sent:
      'An email has been sent to the address entered. Please click the link in the email to finish linking your account.',
    you_have_successfully_enrolled:
      'Once verified by the Office Administrator you will be able to use Payroll Deduct to fund your account.',
    you_have_successfully_removed_payroll_deduct:
      'Payroll Deduct was successfully removed from your payment options.',
    refund_complete: 'Refund Complete!',
    email_sent: 'Email Sent!',
    email_address_verified_details:
      'You can now login with the email address {0}. Future notifications will be sent to this email address',
    now_brewing: 'Now Brewing!',
    collect_your_coffee: 'Please collect your coffee.',
    market_card_changed: 'Market Card Changed',
    market_card_added: 'Market Card Added',
    email_address_already_verified:
      'This email address has already been verified.',
    link_success: 'Account linked successfully',
    device_is_linked: 'Device is linked and ready for use.',
    snack_sent_success: 'Your ${0} snack was sent to {1}.',
    snack_accepted: 'Snack Accepted!',
    accept_amount_has_been_added_to_your_account:
      '${0} has been added to your account.',
    snack_cancelled: 'Snack Cancelled',
    cancelled_amount_has_been_returned_to_your_account:
      '${0} has been returned to your account.',
    sent_successfully: 'Sent Successfully',
    create_account_success:
      'You have created your account! Sign in to start shopping.',
    email_has_been_sent_successfully:
      'An email has been sent.\nClick on the link in the email\nto finish creating your account.',
    create_account_instructions:
      'Click "Continue" to complete setup of your account. An email will be sent with further instructions.',
    working: 'Working...',
    continue: 'Continue',
  },
};

export default English;
